{{#COMPARE mode '==' "weather"}}
	<div class="wizard panel-body">
		<div class="alert alert-info">
			{{TR "Regelmäßige Übertragung von Wetterdaten basierend auf dem Gerätestandort."}}
		</div>
	</div>
{{else}}
	<div class="row">
		{{#unless noValues}}
		<div class="col-sm-6">
			<label>{{TR 'Wert'}}</label>
			{{#SELECT selectedValueID}}
			<select
				id="js-value-select"
				class="selectpicker js-value-select"
				data-live-search="true"
				data-style="btn-white"
				data-title="{{TR 'Wert auswählen'}}">
				{{#each values}}
					<option value="{{this.attributes.id}}">{{TR_DATAPOINT ../deviceCategory this.attributes.name}}</option>
				{{/each}}
			</select>
			{{/SELECT}}
		</div>
		{{/unless}}
		<div class="col-sm-{{#if noValues}}12{{else}}6{{/if}}">
			<label>{{TR 'Gerät'}}</label>
			{{#DEVICE_SELECT sourceDeviceID}}
			<select id="js-device-select" />
			{{/DEVICE_SELECT}}
		</div>
	</div>
	{{#if selectedValueID}}
	<div class="row">
		<div class="col-sm-12 m-t-10">
			<label>{{TR 'Rückfallwerte'}}</label>
		</div>
	</div>
	{{#if showFallback}}
	<div class="row">
		<div class="col-sm-12 m-b-10">
			{{#if canToggleFallbackValues}}
			<div class="checkbox checkbox-primary {{#unless sourceFallbackEnabled}} m-b-0 {{/unless}}" >
				<input
					id="js-source-offline"
					type="checkbox" {{#if sourceFallbackEnabled}}checked="checked"{{/if}}
					name="offline_fallback_value">
				<label  for="js-source-offline">{{TR "Konstanten Wert schreiben, wenn das Quellgerät offline ist"}}</label>
			</div>
			{{/if}}

			{{#if sourceFallbackEnabled}}
				{{#if offlineDetectionEnabled}}<label>{{TR "Offline Wert"}}</label>{{/if}}
				{{#FIELD_VALUE 'offline' valueName rawValues 'offline' '' 'sm'}} {{/FIELD_VALUE}}
			{{/if}}
			{{#if offlineDetectionEnabled}}
				<label class="m-t-5">{{TR "Online Wert"}}</label>
				{{#FIELD_VALUE 'online' valueName rawValues 'online' '' 'sm'}} {{/FIELD_VALUE}}
			{{/if}}
		</div>
	</div>
	{{/if}}

	{{#if targetFallbackDisabled}}
	{{#if disablingReason}}
	<div class="alert alert-info">
		{{disablingReason}}
	</div>
	{{/if}}
	{{else}}
	<div class="row">
		<div class="col-sm-12">
			<div class="checkbox checkbox-primary m-b-0" >
				<input
					id="js-toggle-target-offline"
					type="checkbox" {{#if targetFallbackEnabled}}checked="checked"{{/if}}
					name="target_offline">
				<label for="js-toggle-target-offline">{{TR "Konstanten Wert schreiben, wenn das Zielgerät offline ist"}}</label>
			</div>

			{{#if targetFallbackEnabled}}
				{{> VALUE_TABLE targetOfflineConfiguration}}
			{{/if}}
		</div>
	</div>
	{{#if showFallbackInfo}}
	<div class="alert alert-info m-t-10">{{TR "Die konfigurierten Rückfallwerte sind unabhängig vom gerade ausgewählten Fremdwertbezug und werden geschrieben, wenn das Geräte offline geht."}}</div>
	{{/if}}
	{{/if}}
	{{/if}}
	{{#if refreshRate}}
	<div class="row m-b-20">
		<div class="col-xs-12">
			{{TR 'Änderungen des ausgewählten Wertes werden alle'}} {{refreshRate}} {{TR 'Sekunden übertragen.'}}
		</div>
	</div>
	{{/if}}
{{/COMPARE}}
